/** sessionStorage keys used to persist auth state across reloads. */
export const AUTH_STORAGE_KEYS = {
	ACCESS_TOKEN: "accessToken",
	USER: "user",
} as const

/** User-facing (Russian) error messages shown for various auth failure modes. */
export const AUTH_ERROR_MESSAGES = {
	INVALID_CREDENTIALS: "Неверный email или пароль",
	AUTH_FAILED: "Не удалось войти. Попробуйте ещё раз.",
	FORBIDDEN: "У этой учётной записи нет доступа к бэкофису",
} as const

/** Backend API endpoint paths used by the auth module. */
export const AUTH_ENDPOINTS = {
	LOGIN: "/auth/backoffice",
	TELEGRAM_LOGIN: "/auth/backoffice/telegram",
	TELEGRAM_WIDGET_LOGIN: "/auth/backoffice/telegram-widget",
	CODE_LOGIN: "/auth/backoffice/login-code",
	TELEGRAM_LINK: "/auth/telegram/link-request",
	REFRESH: "/auth/refresh",
	LOGOUT: "/auth/logout",
	ME: "/auth/me",
} as const

/** Бот навигации: выдаёт сотрудникам код входа и привязывает Telegram. */
export const NAVIGATION_BOT = "kmk_nav_bot"

/** Ссылка, по которой бот сразу присылает код для бэкофиса. */
export const BACKOFFICE_CODE_URL = `https://t.me/${NAVIGATION_BOT}?start=backoffice`

/**
 * Виджет Telegram работает только на домене, заданном боту в BotFather (/setdomain),
 * поэтому на остальных адресах его не показываем: там он рисует ошибку.
 */
export const TELEGRAM_WIDGET_HOSTS = ["backoffice.prokmk.ru"]
